export default {"src":"/_next/static/media/tick.2091d855.svg","height":5,"width":5,"blurWidth":0,"blurHeight":0};